import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const SecondarySupervisor = props => {
	const {
		item,
		index,
		agencyContacts,
		primarySupervisor,
		SecondarySupervisorModel,
		updateSecondarySupervisorModel,
	} = props;
	const { lang } = global;

	/** Update the HOC after removing a secondary supervisor row from the form */
	const onRemoveRow = () => {
		const newModel = SecondarySupervisorModel.filter((modelItem, idx) => idx !== index);
		updateSecondarySupervisorModel(newModel);
	};

	/**
	 * Handles changes to properties for a given secondary supervisor
	 * @param {String} property The name of the property to update values for
	 */
	const onChangeRow =
		property =>
		({ target }) => {
			let value;
			if (target.checked !== undefined) value = target.checked;
			else ({ value } = target);

			const newModel = SecondarySupervisorModel.map((modelItem, idx) => {
				if (idx === index) return { ...modelItem, [property]: value };
				return modelItem;
			});

			updateSecondarySupervisorModel(newModel);
		};

	const isDuplicate =
		SecondarySupervisorModel.filter(
			i =>
				i.SecondaryAgencySupervisorId.toString() ===
				item.SecondaryAgencySupervisorId.toString(),
		).length > 1;

	const filteredAgencyContacts = agencyContacts.filter(
		contact => contact.value !== primarySupervisor,
	);

	return (
		<div className="row">
			<div
				className={classNames("col-xs-7 col-sm-8 form-group", {
					"invalid-field": item.SecondaryAgencySupervisorId === "" || isDuplicate,
				})}
			>
				<select
					value={item.SecondaryAgencySupervisorId}
					name={`SecondaryAgencySupervisorId_${index}`}
					onChange={onChangeRow("SecondaryAgencySupervisorId")}
					className="form-control"
				>
					<option value="">--</option>
					<For
						each="item"
						of={filteredAgencyContacts}
					>
						<option
							key={`SS_AgencyContact_${index}_${item.value}`}
							value={item.value}
						>
							{item.label}
						</option>
					</For>
				</select>
			</div>
			<div className="col-xs-3 col-sm-2 checkbox">
				<label htmlFor={`SS_SendNotification_${index}`}>
					<input
						type="checkbox"
						name={`SS_SendNotification_${index}`}
						id={`SS_SendNotification_${index}`}
						checked={item.SendNotification}
						onChange={onChangeRow("SendNotification")}
					/>
					{lang.t("Notify")}
				</label>
			</div>
			<button
				type="button"
				id={`remove-secondary-supervisor_${index}`}
				onClick={() => onRemoveRow()}
				className="col-xs-2 btn btn-link remove-supervisor-btn"
			>
				<i className="rkf rkf-2x rkf-minus-o" />
			</button>
		</div>
	);
};

SecondarySupervisor.propTypes = {
	item: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
	primarySupervisor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	SecondarySupervisorModel: PropTypes.array.isRequired,
	agencyContacts: PropTypes.array,
	updateSecondarySupervisorModel: PropTypes.func.isRequired,
};

SecondarySupervisor.defaultProps = {
	agencyContacts: [],
};

export default SecondarySupervisor;
